import { Action } from '@ngrx/store';
import { PatientData } from '@ispm-shared/modules/patient';

export enum ActionTypes {
  FETCH_PATIENT_DATA = '[Patient] Fetch Patient Data',
  SET_ERROR = '[Patient] Set Error',
  UPDATE_PATIENT_DATA = '[Patient] Update Patient Data'
}

export class FetchPatientDataAction implements Action {
  readonly type = ActionTypes.FETCH_PATIENT_DATA;
  constructor(public payload: { mrn: string}) { }
}

export class SetErrorAction implements Action {
  readonly type = ActionTypes.SET_ERROR;
  constructor(public payload: { error: string }) { }
}

export class UpdatePatientDataAction implements Action {
  readonly type = ActionTypes.UPDATE_PATIENT_DATA;
  constructor(public payload: { patientData: PatientData }) { }
}

export type Actions = FetchPatientDataAction | SetErrorAction | UpdatePatientDataAction;
